import React from "react";
import { profileImgPlaceholder } from "../../../../assets/images";
import { Domain, request } from "../../../../config/API";
import { COLORS } from "../../../../config/theme";
import MainIconBar from "../MainIconBar";
import InfoBox from "../InfoBox";
import { Col, Row } from "antd";
import SocialIconBar from "../SocialIconBar";
const Theme10 = ({
  vCard,
  isPreview,
  downloadVcfFile,
  setShowExchangeCard,
}) => {
  const { primaryColor } = COLORS;
  const {
    fNamePrefix,
    fName,
    lName,
    lNameSuffix,
    email,
    company,
    jobTitle,
    mobile,
    address,
    bgImage,
    profileImage,
    pColor,
    sColor,
    socialLinks,
    leadEnable,
    owner,
    webLinks,
  } = vCard;
  return (
    <Col style={{ width: "100%", backgroundColor: sColor }}>
      <Col
        style={{
          position: "relative",
          background: `linear-gradient(to bottom, rgba(0, 0, 0, 0.3), rgba(0, 0,0, 0.8)),
      ${bgImage ? `url(${Domain}/data/${bgImage})` : pColor}`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          overflow: "hidden",
          backgroundPosition: "center",
          height: "460px",
        }}
      >
        <Row
          style={{
            display: "flex",
            height: "250px",
          }}
        >
          <div
            style={{
              position: "absolute",
              bottom: 0,
              display: "flex",
              backgroundColor: sColor,
              height: 250,
              width: "100%",
              left: 0,
              clipPath: "polygon(0 0, 100% 70%, 100% 100%, 0% 100%)",
            }}
          />
        </Row>
        <Col
          span={24}
          style={{
            position: "absolute",
            display: "flex",
            width: "100%",
            bottom: 20,
            left: 40,
            flexDirection: "column",
          }}
        >
          <Row
            style={{
              display: "flex",
            }}
          >
            <img
              draggable={false}
              style={{
                height: "7rem",
                width: "7rem",
                borderRadius: "1rem",
              }}
              src={
                profileImage
                  ? `${Domain}/data/${profileImage}`
                  : profileImgPlaceholder
              }
              alt=""
            />
          </Row>
          <Row style={{ margin: "10px 0" }}>
            <InfoBox
              fName={fName}
              jobTitle={jobTitle}
              company={company}
              black={false}
            />
          </Row>
          <Row>
            <MainIconBar
              mobile={mobile}
              email={email}
              address={address}
              sColor={sColor}
              horizontal={true}
            />
          </Row>
        </Col>
      </Col>
      <SocialIconBar
        socialLinks={socialLinks}
        leadEnable={leadEnable}
        sColor={sColor}
        downloadVcfFile={downloadVcfFile}
        setShowExchangeCard={setShowExchangeCard}
        owner={owner}
        isBlack={false}
        webLinks={webLinks}
        isPreview={isPreview}
      />
    </Col>
  );
};

export default Theme10;
